import React from "react";
import moment from "moment";
import { formatWithMinDigits } from "../../../../../../../utility/utils";
import { LAB_PRODUCCION_TIPOS_ANALISIS } from "../../../../../../../utility/constants";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";

// Campos que se repiten entre varios tipos de análisis
const CampoPadrePT = ({ padreProductoTerminado }) => (
    <div className="analisis-drc-prod__datos-analisis-field">
        <label htmlFor="padre-producto-terminado">Padre PT:</label>
        <span>{padreProductoTerminado || "N/A"}</span>
    </div>
);

const CampoFechaSolicitud = ({ analisisActual, conHora }) => (
    <div className="analisis-drc-prod__datos-analisis-field">
        <label htmlFor="fecha-solicitud-analisis">Fecha de solicitud:</label>
        <span>
            {analisisActual.fecha_solicitud_analisis
                ? moment(analisisActual.fecha_solicitud_analisis).format(
                      conHora ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY",
                  )
                : "N/A"}
        </span>
    </div>
);

const CampoUsuario = ({ analisisActual }) => (
    <div className="analisis-drc-prod__datos-analisis-field">
        <label htmlFor="usuario">Usuario:</label>
        <span>
            {analisisActual.usuario ? analisisActual.usuario.nombre : "N/A"}
        </span>
    </div>
);

export const DatosAnalisis = ({ analisisActual, detalle }) => {
    if (!analisisActual) {
        return null;
    }

    // Crear componente para mostrar campos específicos según el tipo de análisis
    let detalleEspecifico = null;
    if (
        analisisActual.tipo === LAB_PRODUCCION_TIPOS_ANALISIS.SOBRANTE_ALMACEN
    ) {
        const almacen = detalle ? detalle.almacen : null;
        if (!almacen) {
            return null;
        }

        detalleEspecifico = (
            <React.Fragment>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="almacen">Almacén:</label>
                    <span>{almacen.nombre}</span>
                </div>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="materia-prima">Materia prima:</label>
                    <span>{almacen.materia_prima}</span>
                </div>
                <CampoFechaSolicitud analisisActual={analisisActual} />
                <CampoUsuario analisisActual={analisisActual} />
            </React.Fragment>
        );
    } else if (
        analisisActual.tipo === LAB_PRODUCCION_TIPOS_ANALISIS.TURNO_PRODUCCION
    ) {
        const turno = detalle ? detalle.turno : null;
        if (!turno) {
            return null;
        }
        detalleEspecifico = (
            <React.Fragment>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="turno-produccion">Turno:</label>
                    <span>{turno.turno}</span>
                </div>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="supervisores">Supervisores:</label>
                    <span>{turno.supervisores}</span>
                </div>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="inicio-turno">Inicio turno:</label>
                    <span>
                        {turno.fecha_inicial
                            ? moment(turno.fecha_inicial).format(
                                  "DD/MM/YYYY HH:mm",
                              )
                            : "N/A"}
                    </span>
                </div>
                <CampoPadrePT
                    padreProductoTerminado={detalle.padre_producto_terminado}
                />
            </React.Fragment>
        );
    } else if (
        analisisActual.tipo === LAB_PRODUCCION_TIPOS_ANALISIS.BULTO_SKIM
    ) {
        const bulto = detalle ? detalle.bulto : null;
        if (!bulto) {
            return null;
        }

        const formatIdBultoSkim = (itemId) => {
            if (!itemId) return "";
            else {
                return `B-${formatWithMinDigits(itemId, 4)}`;
            }
        };

        detalleEspecifico = (
            <React.Fragment>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="bulto-skim">Bulto de skim ID:</label>
                    <span>{formatIdBultoSkim(bulto.id)}</span>
                </div>
                <CampoFechaSolicitud analisisActual={analisisActual} conHora />
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="kg-restantes">Kg restantes:</label>
                    <RenderKilogramo value={bulto.kg_humedos_actual} />
                </div>
            </React.Fragment>
        );
    } else if (
        analisisActual.tipo === LAB_PRODUCCION_TIPOS_ANALISIS.MIGA_DESECHO
    ) {
        const miga = detalle ? detalle.miga_desecho : null;
        if (!miga) {
            return null;
        }

        detalleEspecifico = (
            <React.Fragment>
                <div className="analisis-drc-prod__datos-analisis-field">
                    <label htmlFor="semana-miga">Semana:</label>
                    <span>
                        {`${miga.etiqueta_semana} del ${miga.anio} (${miga.rango_semana})`}
                    </span>
                </div>
                <CampoPadrePT
                    padreProductoTerminado={miga.padre_producto_terminado}
                />
                <CampoFechaSolicitud analisisActual={analisisActual} />
                <CampoUsuario analisisActual={analisisActual} />
            </React.Fragment>
        );
    } else {
        detalleEspecifico = (
            <CampoFechaSolicitud analisisActual={analisisActual} />
        );
    }

    return (
        <div className="analisis-drc-prod__datos-analisis mb-2">
            <div className="analisis-drc-prod__datos-analisis-field">
                <label htmlFor="id-solicitud">ID Solicitud:</label>
                <span>{formatWithMinDigits(analisisActual.id)}</span>
            </div>

            <div className="analisis-drc-prod__datos-analisis-field">
                <label htmlFor="tipo-analisis">Tipo de análisis:</label>
                <span>{analisisActual.tipo_display}</span>
            </div>

            {detalleEspecifico}
        </div>
    );
};
